import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dacc0b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thanq" }
const _hoisted_2 = { class: "thanq__content" }
const _hoisted_3 = { class: "thanq__img-wrapper" }
const _hoisted_4 = { class: "mask__list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["href", "alt", "target"]

import { ThankYouPage } from '@/models/ThankYouPage';
import { useInterviewStore } from '@/stores/interviewStore'
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewThanks',
  props: {
    thankYouPage: null
  },
  setup(__props: any) {


const store = useInterviewStore();

onMounted(() => {
    store.eraseCookie('termsOfUse')
    store.eraseCookie('privacyPilicy')
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).progressMasks, (mask, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              src: mask,
              class: "mask__item-image",
              alt: ""
            }, null, 8, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("img", {
          src: __props.thankYouPage.ThanksImage.Url,
          alt: __props.thankYouPage.ThanksImage.Alt,
          class: "thanq__img"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", {
        innerHTML: __props.thankYouPage.ThanksMessage,
        class: "thanq__text"
      }, null, 8, _hoisted_7),
      (__props.thankYouPage.ThanksLink)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: __props.thankYouPage.ThanksLink.Url,
            alt: __props.thankYouPage.ThanksLink.Name,
            target: __props.thankYouPage.ThanksLink.Target,
            class: "thanq__link"
          }, _toDisplayString(__props.thankYouPage.ThanksLink.Name), 9, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})